import { Box, FormControl, Select, MenuItem } from "@mui/material";
import React from "react";

export default function UserTypeCombobox({
  handleSelectChange,
  userTypes,
  selected,
}) {
  return (
    <>
      <Box sx={{ width: "100%", mt: 1, ml: 1 }}>
        <FormControl fullWidth>
          <Select
            labelId="user-group-select-label"
            id="user-group-select"
            defaultValue={selected || 0}
            value={selected}
            onChange={handleSelectChange}
          >
            {userTypes &&
              userTypes.map((item, index) => (
                <MenuItem key={index} value={item.roleId}>
                  {item.roleName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    </>
  );
}
